// Key variables used in local storage
export const AUTH_TOKEN_STORAGE_KEY = 'auth-token';
export const USER_DATA_STORAGE_KEY = 'user-data';
export const USER_INFO_LOCAL_STORAGE_KEY = 'loggedin-user-info';
export const SERVER_CONFIG_STORAGE_KEY = 'server-configs';
export const JWT_AUTH_KEY = 'jwt-auth-token';
export const REPORT_IDS_KEY = 'report-ids';
export const FILTERED_LIST_KEY = 'filtered-list';
export const FILTER_VALUES_KEY = 'filter-values';
export const SELECTED_STUDY_KEY = 'selected-study';
